import { CellContext } from '@tanstack/react-table'

import { StatusChip } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/components/StatusChip'
import { WorkspaceKeyValueSlice } from '../../types'

export const ChipCell = ({
  row: {
    original: { status },
  },
}: CellContext<WorkspaceKeyValueSlice, unknown>) => <StatusChip status={status} />
